import { useRouteError } from "react-router-dom";
import { DefaultErrorBoundary } from "./DefaultErrorBoundary.tsx";

export const RouteErrorBoundary = () => {
  const error = useRouteError();

  return (
    <DefaultErrorBoundary
      error={error}
      onReset={() => {
        window.location.reload();
      }}
    />
  );
};
